module.exports = __webpack_public_path__ + "img/mi-spreekuren.4fc12af0.svg";